import React from "react";
import "./BlogHero.scss";
import { Link } from "react-router-dom";
import { urlForImage } from "../../sanity/image";

import { motion } from "framer-motion";
import { ReactComponent as HeroBtnTag } from "../../assets/svg/heroBtnTag.svg";

const BlogHero = ({ blogPost }) => {
  if (!blogPost) return null;

  const { title, description, coverImage, categories } = blogPost;

  const wordsPerMinute = 20;
  // Calculate estimated reading time
  const contentWords = description?.split(" ").length;
  const readingTime = Math.ceil(contentWords / wordsPerMinute);

  const shortenedDescription =
    description?.length > 100
      ? description.substring(0, 200) + `... (${readingTime} min read)`
      : description;

  return (
    <section className="section blogHero">
      <article className="blogHero__container container">
        <div className="blogHero__container--header">
          <motion.button
            type="button"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 1 }}
          >
            <motion.span
              initial={{ y: 20, opacity: 0, scale: 1.15 }}
              animate={{ y: 0, opacity: 1, scale: 1 }}
              transition={{ duration: 0.8, delay: 0.6 }}
            >
              Blogs
            </motion.span>

            <motion.div
              initial={{ y: 20, opacity: 0, scale: 1.15 }}
              animate={{ y: 0, opacity: 1, scale: 1 }}
              transition={{ duration: 0.8, delay: 0.6 }}
            >
              <HeroBtnTag />
            </motion.div>
          </motion.button>

          <div className="blogHero__container--header-title">
            <motion.h2
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              Our
            </motion.h2>
            <motion.h3
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 1, delay: 0.4 }}
            >
              — Articles...
            </motion.h3>
          </div>

          <motion.p
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1.3, delay: 1.2 }}
            className="contactHero__container--header-subtitle"
          >
            Our thought leadership and best thinking on vision, strategy,
            culture, and brand and how to apply it to your business.
          </motion.p>
        </div>

        <Link
          className="latestBlogLink"
          to={`/blogs/${blogPost.slug.current}`}
          key={blogPost._id}
        >
          <div className="blogHero__container--contents">
            <h3 className="blogHero__container--contents-title">
              LATEST ARTICLE
            </h3>

            <figure className="blogHero__container--contents-img">
              <img
                src={urlForImage(coverImage).url()}
                alt={title}
                title={title}
                width={468}
                height={478}
              />
            </figure>

            <div className="blogHero__container--contents-text">
              <h1 className="contents-text-title">{title}</h1>

              <p className="contents-text-subtitle">{shortenedDescription}</p>

              <div className="contents-text-time">
                <p>4 Min</p>
                <h2>{categories?.join(", ")}</h2>
              </div>
            </div>
          </div>
        </Link>
      </article>
    </section>
  );
};

export default BlogHero;
